/* tslint:disable */
/* eslint-disable */
/**
 * Streem API
 * The Streem API gives you access to information captured during Streem calls.  You can retrieve artifacts such as recordings, streemshots (including captured model/serial numbers), and much more.
 *
 * The version of the OpenAPI document: 0.1.0
 * Contact: support@streem.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function StreemApiNoteFromJSON(json) {
    return StreemApiNoteFromJSONTyped(json, false);
}
export function StreemApiNoteFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'sid': !exists(json, 'sid') ? undefined : json['sid'],
        'createdByUserSid': !exists(json, 'created_by_user_sid') ? undefined : json['created_by_user_sid'],
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'scope': !exists(json, 'scope') ? undefined : json['scope'],
        'scopeSid': !exists(json, 'scope_sid') ? undefined : json['scope_sid'],
        'lastUpdatedByUserSid': !exists(json, 'last_updated_by_user_sid') ? undefined : json['last_updated_by_user_sid'],
        'lastUpdatedAt': !exists(json, 'last_updated_at') ? undefined : (new Date(json['last_updated_at'])),
        'text': !exists(json, 'text') ? undefined : json['text'],
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
        'isFinalizable': !exists(json, 'is_finalizable') ? undefined : json['is_finalizable'],
        'finalizedAt': !exists(json, 'finalized_at') ? undefined : (new Date(json['finalized_at'])),
        'revisionNumber': !exists(json, 'revision_number') ? undefined : json['revision_number'],
    };
}
export function StreemApiNoteToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'sid': value.sid,
        'created_by_user_sid': value.createdByUserSid,
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'scope': value.scope,
        'scope_sid': value.scopeSid,
        'last_updated_by_user_sid': value.lastUpdatedByUserSid,
        'last_updated_at': value.lastUpdatedAt === undefined ? undefined : (value.lastUpdatedAt.toISOString()),
        'text': value.text,
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
        'is_finalizable': value.isFinalizable,
        'finalized_at': value.finalizedAt === undefined ? undefined : (value.finalizedAt.toISOString()),
        'revision_number': value.revisionNumber,
    };
}
/**
* @export
* @enum {string}
*/
export var StreemApiNoteScope;
(function (StreemApiNoteScope) {
    StreemApiNoteScope["ROOM"] = "SCOPE_ROOM";
    StreemApiNoteScope["STREEMSHOT"] = "SCOPE_STREEMSHOT";
    StreemApiNoteScope["INVALID"] = "SCOPE_INVALID";
})(StreemApiNoteScope || (StreemApiNoteScope = {}));
//# sourceMappingURL=StreemApiNote.js.map